import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService } from '../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-new-page-select',
	templateUrl: './new-page-select.component.html',
	styleUrls: ['./new-page-select.component.scss'],
})
export class NewPageSelectComponent implements OnInit {
	pageTitle = '';
	searchMessage = '';
	placeholderMessage = '';
	originalOptionList = [];
	optionList = [];
	displayField: any;
	valueField = '';
	multiSelect = false;
	needFilterSearch = true;
	needTranslation = false;
	selected: any;
	format = '';
	cancelText = '';
	confirmText = '';
	isStaff = false;
	isOrg = false;
	instantClose = false;
	staffNumber = 50;
	staffSearchQuery = [];
	currentPage = 1;
	preventRepeatRequest: boolean = false;
	staffTotal = 0;
	isNotifier = false;
	lastSearchTime = new Date().getTime();
	needShowColor = false;
	showRiskColor = false;

	isLoading = false;
	bbsoStatus = '';
	constructor(
		public dataService: DataService,
		public appService: AppService,
		public router: Router,
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalController: ModalController,
		public localStorageService: LocalStorageService,
		private translateService: TranslateService) {
		let params = this.navParams.data;
		this.pageTitle = params.pageTitle ? params.pageTitle : '';
		this.placeholderMessage = params.placeholderMessage ? params.placeholderMessage : '';
		this.originalOptionList = params.optionList ? params.optionList : [];
		if (params.displayField instanceof Array) {
			this.displayField = params.displayField.length > 0 ? params.displayField : [];
		} else {
			this.displayField = params.displayField ? params.displayField : '';
		}
		this.valueField = params.valueField ? params.valueField : '';
		this.bbsoStatus = params.bbsoStatus ? params.bbsoStatus : '';
		this.multiSelect = params.multiSelect ? params.multiSelect : false;
		if (params.needFilterSearch === false) {
			this.needFilterSearch = false;
		}
		
		if (this.multiSelect) {
			this.selected = params.selected ? params.selected : [];
		} else {
			this.selected = params.selected ? params.selected : '';
		}
		this.needTranslation = params.needTranslation ? params.needTranslation : false;
		this.format = params.format ? params.format : '';
		this.cancelText = params.cancelText ? params.cancelText : 'common.cancel';
		this.confirmText = params.confirmText ? params.confirmText : 'common.confirm';

		// 2024-04-18: SCC-1459，单选点击后自动关闭弹框，默认值改为true
  	// this.instantClose = params.instantClose ? params.instantClose : false;
    this.instantClose = true;

		this.isStaff = params.isStaff;
		this.isNotifier = params.isNotifier;
		this.isOrg = params.isOrg;

		this.staffSearchQuery = params.searchQuery;
		this.staffTotal = params.staffTotal;

		this.needShowColor = params.needShowColor ? params.needShowColor : '';
		this.showRiskColor = params.showRiskColor ? params.showRiskColor : '';
	}

	ngOnInit() {
		// Ionic modal 的 componentProps 是在构造函数之后通过 Object.assign 直接赋值到实例属性上的，
		// 此时才是 pageTitle 的最终原始值（翻译 key），因此翻译必须放在这里而不是构造函数里。
		this.pageTitle = this.translateService.instant(this.pageTitle);
		// 设置标题
		document.getElementsByTagName('title').item(0).innerText = this.pageTitle;
		if (dd.env.platform !== 'notInDingTalk') {
			dd.biz.navigation.setTitle({
				title: this.pageTitle // 钉钉设置导航栏标题
			});
		}
		this.optionList = this.originalOptionList ? this.originalOptionList : [];

		this.processDisplayValue(this.optionList);

		const that = this;
		window.onpopstate = function () {
			const a = document.getElementsByTagName('app-new-page-select');
			if (a.length > 0) {
				setTimeout(() => {
					that.modalController.dismiss();
					// history.back();
				}, 100)
			}
		};
	}

	markSelected(item) {
		if (this.multiSelect) {
			this.selected = this.selected ? this.selected : [];
		} else {
			this.selected = this.selected ? this.selected : '';
		}
		
		if (!this.multiSelect) {
			if (this.valueField !== '$self') {
				this.selected = item[this.valueField];
			} else {
				this.selected = item;
			}
		} else {
			if (this.valueField !== '$self') {
				if (this.selected.indexOf(item[this.valueField]) === -1) {
					this.selected.push(item[this.valueField]);
				} else {
					this.selected.splice(this.selected.indexOf(item[this.valueField]), 1);
				}
			} else {
				if (this.selected.indexOf(item) === -1) {
					console.log('333333');
					if(this.bbsoStatus === 'bbso'){
						this.selected = [item]
					}else{
						this.selected.push(item);
					}
					
				} else {
					this.selected.splice(this.selected.indexOf(item), 1);
				}
			}
		}
		if (!this.multiSelect && this.instantClose) {
			this.confirm();
		}
	}

	isSelected(item) {
		if (this.selected) {
			if (!this.multiSelect) {
				if (this.valueField !== '$self') {
					return this.selected === item[this.valueField];
				} else {
					return this.selected.id === item.id;
				}
			} else {
				if (this.valueField !== '$self') {
					return this.selected.indexOf(item[this.valueField]) !== -1;
				} else {
					return this.selected.some(element => element.id === item.id);
				}
			}
		}
		return false;
	}

	filterOptionList() {
		if (this.searchMessage) {
			let filteredList = [];
			if (this.displayField instanceof Array) {
				filteredList = this.originalOptionList.filter(item => {
					let filterRawInfo = '';
					if (item.lastName && item.firstName) {
						let lastName = item.lastName
						if (lastName.charCodeAt(0) > 255) {
							item.full_name = item.lastName + item.firstName;
						}
					}
					this.displayField.forEach(field => {
						filterRawInfo += item[field];
					});
					return filterRawInfo.toLowerCase().indexOf(this.searchMessage.toLowerCase()) !== -1;
				});
			} else {
				filteredList = this.originalOptionList.filter(item => item[this.displayField].toLowerCase().indexOf(this.searchMessage.toLowerCase()) !== -1);
			}
			this.optionList = filteredList;
		} else {
			this.optionList = this.originalOptionList;
		}
		this.processDisplayValue(this.optionList);
	}

	async cancel() {
		await this.modalController.dismiss();
		history.back();
	}

	async confirm() {
		this.isLoading = true;
		if (this.selected instanceof Array) {
			this.selected.forEach(item => {
				if (item.hasOwnProperty('finalDisplay')) {
					delete item.finalDisplay;
				}
			});
		} else {
			if (this.selected.hasOwnProperty('finalDisplay')) {
				delete this.selected.finalDisplay;
			}
		}

		await this.modalController.dismiss(this.selected);
		this.isLoading = false;
		history.back();
	}

	processDisplayValue(list: any[]) {
		if (this.displayField instanceof Array) {
			if (this.format) {
				list.forEach(item => {
					item.finalDisplay = this.format;
					if (item.lastName && item.firstName) {
						let lastName = item.lastName
						if (lastName.charCodeAt(0) > 255) {
							item.full_name = item.lastName + item.firstName;
						}
					}
					this.displayField.forEach((field, index) => {
						item.finalDisplay = item.finalDisplay.replace(('$' + (index + 1)), item[field]);
					});
				});
			}
		} else {
			list.forEach(item => {
				item.finalDisplay = item[this.displayField];
			});
		}
	}

	loadMore(event: any) {
		if (this.staffTotal > this.originalOptionList.length) {
			if (this.isStaff) {
				this.getStaffData(event);
			} else if (this.isNotifier) {
				this.getNotifierfData(event);
			} else if (this.isOrg) {
				this.getOrgData(event);
			}
		} else {
			event.target.complete();
		}
	}

	async getStaffData(event): Promise<any> {
		const param = {
			pagingTool: {
				currentPage: this.currentPage + 1,
				pageSize: 50
			},
			queryCriterias: this.staffSearchQuery,
			queryOrderBies: [{
				columnName: 'code',
				orderType: 'DESC'
			}]
		};
		const that = this;
		const promise = new Promise<void>((resolve, reject) => {
			that.dataService.getStaffList(param).subscribe(res => {
				if (res && res.STATUS === 0) {
					event.target.complete();
					this.currentPage++;
					this.originalOptionList = this.originalOptionList.concat(res.DATA);
					this.filterOptionList();
					resolve();
				} else {
					that.appService.toastTip(res.MSG, false);
					reject();
				}
			});
		});
		return promise;
	}

	async getNotifierfData(event): Promise<any> {
		const param = {
			pagingTool: {
				currentPage: this.currentPage + 1,
				pageSize: 50
			},
			queryCriterias: this.staffSearchQuery,
			queryOrderBies: [{
				columnName: 'code',
				orderType: 'DESC'
			}]
		};
		const that = this;
		that.dataService.getEmployeesDivisionalList(param).then(res => {
			if (res && res.STATUS === 0) {
				event.target.complete();
				res.DATA.forEach(v => {
					v.tempOrgName = v.orgs && v.orgs.length ? v.orgs[0]['full_name'] : '';
				});
				this.currentPage++;
				this.originalOptionList = this.originalOptionList.concat(res.DATA);
				this.filterOptionList();
			} else {
				that.appService.toastTip(res.MSG, false);
			}
		});
	}

	async getOrgData(event): Promise<any> {
		const param = {
			pagingTool: {
				currentPage: this.currentPage + 1,
				pageSize: 50
			},
			queryCriterias: this.staffSearchQuery,
			queryOrderBies: []
		};
		const that = this;
		const promise = new Promise<void>((resolve, reject) => {
			that.dataService.getOrgListTable(param).subscribe(res => {
				if (res && res.STATUS === 0) {
					event.target.complete();
					this.currentPage++;
					this.originalOptionList = this.originalOptionList.concat(res.DATA);
					this.filterOptionList();
					resolve();
				} else {
					that.appService.toastTip(res.MSG, false);
					reject();
				}
			});
		});
		return promise;
	}
}
